export default function WhatIsParagraph({ text }: { text: string }) {
  return <div>
    {text}
  </div>
}
